import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <div className="hear_footer">
      <p className="m-0">
        © echo<b>ears</b> Pvt. Ltd. All Rights Reserved
      </p>
    </div>
  );
};
export default Footer;
